import { apiClient } from '@twlvxtwlv/api'
import type { VoucherRedemptionRequestBodySchema } from '@twlvxtwlv/types'

export function completeOrderWithVoucher(input: VoucherRedemptionRequestBodySchema) {
  return apiClient.post(`/api/voucher-redemption-checkout`, input)
}
